import * as types from '../actions/types';

const initialState = {
  list: [],
  faculty: null,
  teachers: [],
  loading: false,
  total: 0,
  pageCount: 0
};

export default function faculty(state = initialState, action) {
  switch (action.type) {
    case types.FACULTY_LIST_FETCH_COMPLETED:
      return {
        ...state,
        list: action.list,
        total: action.total,
        pageCount: action.pageCount
      };
    case types.FACULTY_FETCH_COMPLETED:
      return {
        ...state,
        faculty: action.faculty,
      };
    case types.FACULTY_TEACHERS_FETCH_COMPLETED:
      return {
        ...state,
        teachers: action.teachers.map(t => `${t.firstname} ${t.lastname} ${t.patronymic}`),
      };
    case types.SET_FACULTY_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    default:
      return state;
  }
}
